import { render, staticRenderFns } from "./FilterByTags.vue?vue&type=template&id=66b1d9f0&scoped=true&"
import script from "./FilterByTags.vue?vue&type=script&lang=ts&"
export * from "./FilterByTags.vue?vue&type=script&lang=ts&"
import style0 from "./FilterByTags.vue?vue&type=style&index=0&id=66b1d9f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1d9f0",
  null
  
)

export default component.exports